var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 9.44922C0.25 9.61849 0.279297 9.77474 0.337891 9.91797C0.402995 10.0612 0.500651 10.1979 0.630859 10.3281L8.23828 17.7695C8.45964 17.9909 8.72656 18.1016 9.03906 18.1016C9.25391 18.1016 9.44596 18.0495 9.61523 17.9453C9.79102 17.8477 9.93099 17.7109 10.0352 17.5352C10.1393 17.3659 10.1914 17.1771 10.1914 16.9688C10.1914 16.6562 10.071 16.3796 9.83008 16.1387L2.97461 9.44922L9.83008 2.75977C10.071 2.51888 10.1914 2.24544 10.1914 1.93945C10.1914 1.72461 10.1393 1.53255 10.0352 1.36328C9.93099 1.19401 9.79102 1.06055 9.61523 0.962891C9.44596 0.858724 9.25391 0.806641 9.03906 0.806641C8.72656 0.806641 8.45964 0.914062 8.23828 1.12891L0.630859 8.57031C0.500651 8.70052 0.402995 8.83724 0.337891 8.98047C0.279297 9.1237 0.25 9.27995 0.25 9.44922Z",
    fill: "#33D085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrev);
export default __webpack_public_path__ + "static/media/ico_prev.7455c58056ce999cb057fb11449fda49.svg";
export { ForwardRef as ReactComponent };